export default {
  tradeInId: {
    id: 'buyback_product_info_trade_in_id_label',
    defaultMessage: 'Trade-in ID',
  },
  orderIdCopied: {
    id: 'buyback_product_info_trade_in_id_copied',
    defaultMessage: 'Trade-in ID copied',
  },
}
